import scheduleMaintenance from './middleware/scheduleMaintenance'
import admin from './middleware/admin'
import adminAndAcu from './middleware/adminAndAcu'
import checkAPI from './middleware/checkAPI'
import authAdmin from './middleware/authAdmin'

export default [
    // Admin - Define navBar
    {
        path: '/admin',
        name: 'admin',
        meta: {
            breadcrumb: 'Home',
            title: 'Menu',
            middleware: [authAdmin, scheduleMaintenance, checkAPI, admin]
        },
        component: () => import('./../components/DashboardAdmin/IndexPage.vue'),
        children: [
            // Admin - Manage Account
            {
                path: 'manageaccount',
                name: 'adminManageAccount',
                meta: {
                    breadcrumb: 'Manage Account',
                    title: 'Manage Account',
                    middleware: [authAdmin, scheduleMaintenance, checkAPI, adminAndAcu]
                },
                component: () => import('./../components/DashboardAdmin/ManageAccount/IndexPage.vue')
            },

            // Admin / Util
            {
                path: 'util',
                name: 'utilMenu',
                meta: {
                    breadcrumb: 'Util',
                    title: 'Util',
                    middleware: [authAdmin, scheduleMaintenance, checkAPI, admin]
                },
                component: () => import('./../components/DashboardAdmin/Util/IndexPage.vue'),
                children: [
                    // Admin / Util - Cancel Portal Approval
                    {
                        path: 'cancel-approval',
                        name: 'cancelApproval',
                        meta: {
                            breadcrumb: 'Cancel Portal Approval',
                            title: 'Cancel Portal Approval',
                            middleware: [authAdmin, scheduleMaintenance, checkAPI, admin]
                        },
                        component: () => import('./../components/DashboardAdmin/Util/CancelApproval/IndexPage.vue')
                    }
                ]
            },

            // Admin / Claims - List of Ledgers
            {
                path: 'claims/ledgers',
                name: 'ledgers',
                meta: {
                    breadcrumb: 'Ledgers',
                    title: 'Ledgers',
                    middleware: [authAdmin, scheduleMaintenance, checkAPI, admin]
                },
                component: () => import('./../components/DashboardAdmin/Claims/LedgersPage.vue')
            },

            // Admin - Providers => Menu
            {
                path: 'providers',
                name: 'providersMenu',
                meta: {
                    breadcrumb: 'Providers',
                    title: 'Providers\' Menu',
                    middleware: [authAdmin, scheduleMaintenance, checkAPI, admin]
                },
                component: () => import('./../components/DashboardAdmin/Providers/IndexPage.vue'),
                children: [
                    // Admin - Providers => New
                    {
                        path: 'new',
                        name: 'newProvider',
                        meta: {
                            breadcrumb: 'New',
                            title: 'New Provider',
                            middleware: [authAdmin, scheduleMaintenance, checkAPI, admin]
                        },
                        component: () => import('./../components/DashboardAdmin/Providers/NewProvider.vue')
                    },

                    // Admin - Providers => Link and unlink
                    {
                        path: 'link-unlink',
                        name: 'linkUnlink',
                        meta: {
                            breadcrumb: 'Link-Unlink',
                            title: 'Link & Unlink Provider',
                            middleware: [authAdmin, scheduleMaintenance, checkAPI, admin]
                        },
                        component: () => import('./../components/DashboardAdmin/Providers/LinkUnlinkProvider/IndexPage.vue')
                    },

                    // Admin - Providers => Reports
                    {
                        path: 'reports',
                        name: 'reports',
                        meta: {
                            breadcrumb: 'Reports',
                            title: 'Provider Reports',
                            middleware: [authAdmin, scheduleMaintenance, checkAPI, admin]
                        },
                        component: () => import('./../components/DashboardAdmin/Providers/Reports/IndexPage.vue')
                    },

                    // Admin - Providers => Validation Logs
                    {
                        path: 'validation-logs/',
                        name: 'validationLogs',
                        meta: {
                            breadcrumb: 'Validation Logs',
                            title: 'Validation Logs',
                            middleware: [authAdmin, scheduleMaintenance, checkAPI, admin]
                        },
                        component: () => import('./../components/DashboardAdmin/Providers/ValidateLogs/IndexPage.vue')
                    }
                ]
            },

            // Admin - Acu
            {
                path: 'acu',
                name: 'acuMenu',
                meta: {
                    breadcrumb: 'ACU',
                    title: 'Annual Checkup',
                    middleware: [authAdmin, scheduleMaintenance, checkAPI, adminAndAcu]
                },
                component: () => import('./../components/DashboardAdmin/Acu/IndexPage.vue'),
                children: [
                    {
                        path: 'revalidate',
                        name: 'acuRevalidate',
                        meta: {
                            breadcrumb: 'Revalidate',
                            middleware: [authAdmin, scheduleMaintenance, checkAPI, adminAndAcu]
                        },
                        component: () => import('./../components/DashboardAdmin/Acu/Revalidate/IndexPage.vue')
                    },
                    {
                        path: 'account-provisions',
                        name: 'acuAccountProvisions',
                        meta: {
                            breadcrumb: 'Account Provisions',
                            middleware: [authAdmin, scheduleMaintenance, checkAPI, adminAndAcu]
                        },
                        component: () => import('./../components/DashboardAdmin/Acu/AccountProvisions/IndexPage.vue')
                    },
                    {
                        path: 'provider-settings',
                        name: 'providerSettings',
                        meta: {
                            breadcrumb: 'Provider Settings',
                            middleware: [authAdmin, scheduleMaintenance, checkAPI, adminAndAcu]
                        },
                        component: () => import('./../components/DashboardAdmin/Acu/ProviderSettings/IndexPage.vue'),
                        children: [
                            {
                                path: 'rates',
                                name: 'acuRates',
                                meta: {
                                    breadcrumb: 'Rates',
                                    middleware: [authAdmin, scheduleMaintenance, checkAPI, adminAndAcu]
                                },
                                component: () => import('./../components/DashboardAdmin/Acu/ProviderSettings/ACURates/IndexPage.vue')
                            },
                            {
                                path: 'groups',
                                name: 'acuGroups',
                                meta: {
                                    breadcrumb: 'Groups',
                                    middleware: [authAdmin, scheduleMaintenance, checkAPI, adminAndAcu]
                                },
                                component: () => import('./../components/DashboardAdmin/Acu/ProviderSettings/ACUGroups/IndexPage.vue')
                            },
                            {
                                path: 'provider-acu-info',
                                name: 'providerAcuInfo',
                                meta: {
                                    breadcrumb: 'Provider Acu Info',
                                    middleware: [authAdmin, scheduleMaintenance, checkAPI, adminAndAcu]
                                },
                                component: () => import('./../components/DashboardAdmin/Acu/ProviderSettings/ProviderAcuInfo/IndexPage.vue')
                            }
                        ]
                    },

                    {
                        path: 'reports',
                        name: 'acuReports',
                        meta: {
                            breadcrumb: 'Reports',
                            middleware: [authAdmin, scheduleMaintenance, checkAPI, adminAndAcu]
                        },
                        component: () => import('./../components/DashboardAdmin/Acu/ReportPage.vue')
                    },
                    {
                        path: 'member-qualification',
                        name: 'memberQualification',
                        meta: {
                            breadcrumb: 'Member Qualification',
                            middleware: [authAdmin, scheduleMaintenance, checkAPI, adminAndAcu]
                        },
                        component: () => import('./../components/DashboardAdmin/Acu/MemberQualification/IndexPage.vue')
                    },
                    {
                        path: 'cancel-acu-approval',
                        name: 'cancelAcuApproval',
                        meta: {
                            breadcrumb: 'Cancel ACU Approval',
                            middleware: [authAdmin, scheduleMaintenance, checkAPI, adminAndAcu]
                        },
                        component: () => import('./../components/DashboardAdmin/Acu/CancelAcuApproval/IndexPage.vue')
                    }
                ]
            },

            // Admin - Members => Menu
            {
                path: 'members/',
                name: 'membersMenu',
                meta: {
                    breadcrumb: 'Members',
                    middleware: [authAdmin, scheduleMaintenance, checkAPI, admin]
                },
                component: () => import('./../components/DashboardAdmin/Members/IndexPage.vue'),
                children: [
                    {
                        path: 'reports/',
                        name: 'member_reports',
                        meta: {
                            breadcrumb: 'Reports',
                            middleware: [authAdmin, scheduleMaintenance, checkAPI, admin]
                        },
                        component: () => import('./../components/DashboardAdmin/Members/Reports/IndexPage.vue')
                    }
                ]
            }
        ]
    }
]
